module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/caret-up-e361bdd74e75137e9d405f383ea1d374.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/caret-up.svg
// module id = hVp0
// module chunks = 24